module.exports = "/_next/static/images/amex@2x-1b0b857e5fb9385c87906e7a7c6d797d.png";